import styled from 'styled-components';

export const Loading = styled.span`
  content: 'Loading...';
`;
